import React, { useState, useEffect } from 'react';
import moment from 'moment';
import { Grid, Segment, Button, Icon, Image, Modal } from 'semantic-ui-react';
import useBreakpoint from 'antd/lib/grid/hooks/useBreakpoint';
import { CheckOutlined } from '@ant-design/icons';
import UrlParse from 'url-parse';
import BackButton from '../../components/BackButton';
import GeneralHelper from '../../helpers/general';
import LabelHelper from '../../helpers/Label';

const ReserveMachinePage = (props) => {
	const {
		location,
		history,
		getTicketById,
		getMachines,
		updateTicketById,
		resetPage,
		resetMeta,
		reserveMachinePageProps
	} = props;

	const { ticket, machines, meta } = reserveMachinePageProps;
	const { query } = UrlParse(location.search, true);

	const [selectedMachine, setSelectedMachine] = useState(null);
	const [modalConfirmMachine, setModalConfirmMachine] = useState(false);
	const [modalReserveSuccess, setModalReserveSuccess] = useState(false);

	useEffect(() => {
		query.id && getTicketById(query.id);

		return () => resetPage();
	}, [getTicketById, query.id, resetPage]);

	useEffect(() => {
		if (ticket) {
			const { laundry_room_id, service_type_id, selected_machine_id } = ticket;

			if (selected_machine_id) {
				history.push(`/tickets/id?id=${query.id}`)
				return;
			}

			getMachines({
				laundry_room_id,
				service_type_id
			});
		}
	}, [getMachines, ticket]);

	useEffect(() => {
		if (meta?.code === 200) {
			setModalReserveSuccess(true);
		}
	}, [meta]);

	const customFontSize = () => {
		// eslint-disable-next-line react-hooks/rules-of-hooks
		const { md, sm, xs } = useBreakpoint();
		return xs ? {
			fontFamily: 'sans-serif',
			fontSize: '10px',
			fontWeight: 'bold',
			lineHeight: 1.4,
			marginLeft: 10,
			marginRight: 10
		} : sm && !md ? {
			fontFamily: 'sans-serif',
			fontSize: '11px',
			fontWeight: 'bold',
			lineHeight: 1.3,
			marginLeft: 10,
			marginRight: 10
		} : md && {
			fontFamily: 'sans-serif',
			fontSize: '15px',
			fontWeight: 'bold',
			marginLeft: 10,
			marginRight: 10
		};
	};

	const modalConfirm = () => {
		const machine = machines.filter(machine => machine._id === selectedMachine)[0];
		return (
			<Modal
				style={{width: 400}}
				open={modalConfirmMachine}
				onClose={() => setModalConfirmMachine(false)}
			>
				<Modal.Header style={{borderBottom: '1px solid #DFDFDF', fontWeight: 'normal', fontSize: '15px', color: '#003366' }}>Activate Machine</Modal.Header>
				<Modal.Content style={{ padding: '14.5px', background: '#fff' }}>
					<Grid style={{ background: '#fff' }}>
						<Grid.Row style={{ background: '#fff' }}>
							<Grid.Column style={{ padding: '10px 20px', background: '#fff', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
								<div style={{ textAlign: 'center' }}>You are activating {machine?.name} for a {machine?.service_type?.label} service. Press "Proceed" to continue.</div>
								<div style={{ marginTop: 20 }}>Are you sure you want to proceed?</div>
							</Grid.Column>
						</Grid.Row>
					</Grid>
				</Modal.Content>
				<Modal.Actions style={{ padding: 0, borderTop: '1px solid #DFDFDF', display: 'flex', flex: 1, flexDirection: 'row'}}>
					<Button
						style={{ width: '50%', margin: 0, padding: 20, background: '#fff', fontWeight: 'normal', borderRight: '0.5px solid #DFDFDF', borderRadius: 0 }}
						content="Cancel"
						onClick={() => setModalConfirmMachine(false)}
					/>
					<Button
						style={{ width: '50%', margin: 0, padding: 20, background: '#fff', color: '#0088FF', fontWeight: 'normal', borderLeft: '0.5px solid #DFDFDF', borderRadius: 0 }}
						content="Proceed"
						onClick={() => updateTicketById({ selected_machine_id: selectedMachine, action: 'machine_reserve' })}
					/>
				</Modal.Actions>
			</Modal>
		);
	};

	const modalSuccess = () => {
		return (
			<Modal
				open={modalReserveSuccess}
				style={{ padding: '20px 20px', textAlign: 'center', width: 200 }}
			>
				<CheckOutlined style={{ backgroundColor: '#008000a1', color: '#fff', fontSize: 35, borderRadius: 40, padding: 15 }} />
				<h4>Activation Successful</h4>
				<div
					style={{ marginTop: 30, alignSelf: 'center', cursor: 'pointer' }}
					onClick={() => props.history.push(`/tickets/id?id=${ticket._id}`)}
				>
					<p style={{ color: '#7d9bdb', textAlign: 'center' }}>OK</p>
				</div>
			</Modal>
		);
	};

	return (
		<div className="page-wrapper">
			<Grid container>
				<BackButton
					returnLocation={`tickets/id?id=${ticket?._id}`}
					returnName="Ticket Detail"
					{...props}
				/>
				<Grid.Row style={{ background: '#fff', borderRadius: 5, boxShadow: '0 2px 5px 0 rgba(0,0,0,0.2), 0 1px 2px 0 rgba(0,0,0,0.19)' }}>
					<div
						style={{
							display: 'flex',
							flexDirection: 'row',
							flexWrap: 'nowrap',
							justifyContent: 'space-between',
							width: '100%',
							margin: '0px 15px 20px 15px',
							verticalAlign: 'center'
						}}
					>
						<div style={{ display: 'flex', alignItems: 'center' }}>
							<p style={{ fontSize: 15, color: '#075185', fontWeight: 'bold' }}>
								Activate a {ticket?.machine_type === 'washer' ? 'Washing' : 'Dryer'} Machine
							</p>
						</div>
						<div style={{ display: 'flex', alignItems: 'center' }}>
							<p
								onClick={() => props.history.push('/purchase-history')}
								style={{ fontSize: 14, marginRight: '20px', marginTop: '10px', color: '#0088FF', cursor: 'pointer' }}
							>
								Purchase History
							</p>
							<Button
								style={{ width: '180px', border: '2px solid', borderColor: '#0088FF', borderRadius: '50px', background: '#fff' }}
								disabled={!selectedMachine}
								onClick={() => setModalConfirmMachine(true)}
							>
								<CheckOutlined style={{ fontSize: 16, color: '#0088FF' }} />
								<p style={{ display: 'inline-block', marginLeft: '5px', color: '#0088FF' }}>Activate Machine</p>
							</Button>
						</div>
					</div>
					<Grid.Column
						tablet={16}
						computer={16}
					>
						<Grid.Row style={{ marginBottom: 10 }}>
							<Grid.Column>
								<Segment>
									<div style={{ margin: '10px' }}>
										<p style={{ fontSize: '14px', color: '#205181', fontWeight: '510' }}>
											Choose a machine
										</p>
									</div>
									<div style={{ minHeight: 500, display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
										<div>
											{
												machines.length > 0 && machines.map((machine, index) => {
													let status = '';

													if (machine.status === 'enabled' && machine.state === 'available'){
														status = "Available";
													}

													if (machine.status === 'disabled') {
														status = "Disabled";
													}

													if (machine.status === 'on_hold') {
														status = "On Hold";
													}

													if (machine.status === 'maintenance') {
														status = "Maintenance";
													}

													if(machine.state === 'offline') {
														status = "Offline";
													}

													if(machine.state === 'in_use') {
														status = "In-Use";
													}

													return (
														<div
															key={index}
															style={{
																borderTop: selectedMachine === machine._id ? '2px solid #1D4FB2' : '1px solid #D5D5D5',
																borderBottom: selectedMachine === machine._id ? '2px solid #1D4FB2' : '1px solid #D5D5D5',
																borderLeft: selectedMachine === machine._id ? '2px solid #1D4FB2' : '1px solid #D5D5D5',
																// borderRight: `5px solid ${machine.status === 'available' ? '#00B08D' : machine.status === 'in_use' ? '#FAA61A' : '#CCCCCC'}`,
																borderRight: `5px solid ${status === 'Available' ? '#00B08D' : (status === 'Disabled'  ||  status === 'Maintenance' || status === 'Offline' || status === 'On Hold') ? '#CCCCCC' : '#FAA61A' }`,
																display: 'flex',
																flexDirection: 'row',
																padding: '5px 15px',
																alignContent: 'center',
																alignItems: 'center',
																margin: '0px 10px 10px 10px',
																borderRadius: '7px',
																cursor: 'pointer'
															}}
															// onClick={() => machine.status === 'available' && setSelectedMachine(machine._id)}
															onClick={() => (machine.status === 'enabled' && machine.state === 'available') && setSelectedMachine(machine._id)}
														>
															<div style={{ display: 'flex', flexDirection: 'row', width: '100%' }}>
																<div style={{ marginRight: 15 }}>
																	<Image
																		src={`${
																			GeneralHelper.getImageBasePath()}/images/${machine.status === 'enabled' ?
																			ticket?.machine_type === 'washer' ? 'washing-machine-available' : 'dryer-available' :
																			machine.state === 'in_use' ?
																			ticket?.machine_type === 'washer' ? 'washing-machine-in-use' : 'dryer-in-use' :
																		ticket?.machine_type === 'washer' ? 'washing-machine-maintenance' : 'dryer-maintenance'}.svg`}
																		style={{ width: 50, height: 50 }}
																	/>
																</div>
																<div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
																	<small style={{ fontSize: 12, fontWeight: 'bold', color: '#2B6395' }}>{ machine?.service_type?.label }</small>
																	<small style={{ fontSize: 12, fontWeight: 'bold', color: '#2B6395' }}>{ machine.name }</small>
																	<small
																		style={{
																			fontSize: 11,
																			color: `${status === 'Available' ? '#00B08D' : (status === 'Disabled'  ||  status === 'Maintenance' || status === 'Offline' || status === 'On Hold') ? '#CCCCCC' : '#FAA61A' }`
																		}}
																	>
																		{ `${
																			status === 'In-Use'
																				? (machine.job
																					? status + ` (Last activated ${
																						ticket?.machine_type === 'washer'
																							? `at ${moment(machine?.job?.created_at).format('LLL')})`
																							: `for ${machine?.job?.ticket?.number_of_minutes} min(s) at ${moment(machine?.job?.created_at).format('LLL')})`
																					}`
																					: status
																				)
																				: status
																		}` }
																	</small>
																</div>
																<div style={{ width: '100%', display: 'flex', flex: 1, flexDirection: 'row', justifyContent: 'flex-end', alignItems: 'center'}}>
																	{
																	// machine.status === 'available' && (
																		(machine.status === 'enabled' && machine.state === 'available') && (
																			<Icon
																				name="arrow right"
																				// style={{ marginBottom: 5, color: `${machine.status === 'available' ? '#00B08D' : machine.status === 'in_use' ? '#FAA61A' : '#CCCCCC'}` }}
																				style={{ marginBottom: 5, color: `${status === 'Available' ? '#00B08D' : (status === 'Disabled'  ||  status === 'Maintenance' || status === 'Offline' || status === 'On Hold') ? '#CCCCCC' : '#FAA61A' }` }}
																			/>
																		)
																	}
																</div>
															</div>
														</div>
													);
												})
											}
										</div>
										<div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '30%', fontFamily: 'sans-serif', fontWeight: 'bold', ...customFontSize() }}>
											<div style={{ display: 'flex', flexDirection: 'row' }}>
												<div style={{ display: 'flex', flexDirection: 'column', height: '100%', color: '#2B6395', marginBottom: 10}}>
													<span>If the machine is not in operation but is still with the status "In-Use," there are two possible scenarios:</span>
													<span style={{margin: 15}}>
														1. The time gap between the user clicking "Activate a machine" and scanning the QR code.<br/>
														2. The last laundry cycle has been completed, but the user has not opened the door to end the current cycle.
													</span>
													<span>You are advised to check the machine’s status on-site and to confirm if it is available to use.</span>
												</div>
											</div>
										</div>
									</div>
								</Segment>
							</Grid.Column>
						</Grid.Row>
					</Grid.Column>
				</Grid.Row>
			</Grid>
			{modalConfirm()}
			{modalSuccess()}
		</div>
	);
};

export default ReserveMachinePage;
